import LogHoursPage from "./LogHoursPage";

export default LogHoursPage;
